function getFirstCharacter(word: string): string {
  const characterMatchArray = word.match(/[a-zA-Z0-9]/);
  return characterMatchArray ? characterMatchArray[0] : '';
}

export function generateAbbreviation(text: string): string {
  if (!text) {
    return '';
  }

  const textParts = text.split(' ');
  const wordsFirstCharacter = textParts.map((textPart) => getFirstCharacter(textPart).toUpperCase()).filter(Boolean);

  if (wordsFirstCharacter.length === 1) {
    return wordsFirstCharacter[0];
  }

  return wordsFirstCharacter[0] + wordsFirstCharacter[wordsFirstCharacter.length - 1];
}
